import ECSSheet from 'components/editor/ECSSheet';
import React, { FC } from 'react';
import { Sheet as SheetRecord } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';

type Props = {
  sheet: SheetRecord;
  withMarkups: boolean;
  isInteractive?: boolean;
};

// This component handles the business for loading an ECSSheet from a Sheet
const ECSEditorSheet: FC<Props> = (props: Props) => {
  const { sheet, withMarkups, isInteractive } = props;
  const {
    documentid,
    pageid,
    width,
    height,
    drawingtilescloudfronturl,
    drawingmaxzoom,
    drawingminzoom,
    drawingtilesize,
  } = sheet.versions.last<SheetVersion>();

  return (
    <ECSSheet
      documentid={documentid}
      pageid={pageid}
      width={width}
      height={height}
      sheet={sheet}
      withMarkups={withMarkups}
      isInteractive={isInteractive}
      drawingtilescloudfronturl={drawingtilescloudfronturl}
      drawingmaxzoom={drawingmaxzoom}
      drawingminzoom={drawingminzoom}
      drawingtilesize={drawingtilesize}
    />
  );
};

export default ECSEditorSheet;
